import {
    NotificationManager,
    Notification,
} from '@alfa-retail-react/components';
import React, { useContext, useState } from 'react';

type AddNotificationProps = {
    title?: string;
    delay?: number;
    badge?: 'negative' | 'positive' | 'attention';
};

const NotificationContext =
    React.createContext<NotificationContextManager>(null);

export const NotificationContextProvider = ({
    children,
}: {
    children: React.ReactNode;
}) => {
    const [notifications, setNotifications] = useState([]);

    const addNotification = ({ title, delay, badge }: AddNotificationProps) => {
        const DEFAULT_BADGE = 'negative';
        const DEFAULT_NOTIFICATION_DELAY = 5000;
        const DEFAULT_NOTIFICATION_MESSAGE =
            'Не удалось выполнить операцию. Попробуйте ещё раз позже';

        const newNotification = (
            <Notification
                badge={badge || DEFAULT_BADGE}
                autoCloseDelay={delay || DEFAULT_NOTIFICATION_DELAY}
                id={notifications.length.toString()}
                key={notifications.length.toString()}
            >
                {title || DEFAULT_NOTIFICATION_MESSAGE}
            </Notification>
        );
        notifications.unshift(newNotification);
        setNotifications([...notifications]);
    };

    const removeNotification = React.useCallback((id: string) => {
        /**
         * Обратите внимание, что актуальный массив нотификаций
         * нужно брать из аргументов функции обновления состояния.
         */
        setNotifications((actualNotifications) =>
            actualNotifications.filter(
                (notification) => notification.props.id !== id,
            ),
        );
    }, []);

    return (
        <NotificationContext.Provider value={{ addNotification }}>
            {children}
            <NotificationManager
                notifications={notifications}
                onRemoveNotification={removeNotification}
            />
        </NotificationContext.Provider>
    );
};

export interface NotificationContextManager {
    addNotification: (options: AddNotificationProps) => void;
}

export const useNotificationContext = (): NotificationContextManager => {
    return useContext<NotificationContextManager>(NotificationContext);
};
